import Delegate from 'ftdomdelegate'

import CountrySelector from './country-selector'
import Currency from '../tools/currency'
import Animation from '../tools/animation'

export default class ShippingEstimator {
  constructor(element) {

    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.countrySelector = new CountrySelector(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'));
    this._attachListeners();
    console.log(element);
  }

  onUnload() {
    this.delegateElement.off('click');
    this.countrySelector.destroy();
  }
  _attachListeners() {
    this.delegateElement.on('click', '.shippingEstimator__submit', this._fetchRates.bind(this));
  }
  _fetchRates() {
    var _this13 = this;

    var country = this.element.querySelector('[name="country"]').value,
        province = this.element.querySelector('[name="province"]').value,
        zip = this.element.querySelector('[name="zip"]').value;

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch('/cart/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country + '&shipping_address[province]=' + province, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (response) {
      response.json().then(function (result) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        var resultsContainer = _this13.element.querySelector('.shippingEstimator__results'),
            errorContainer = _this13.element.querySelector('.shippingEstimator__error');

        if (response.ok) {
          var shippingRates = result['shipping_rates'];

          if (shippingRates.length === 0) {
            resultsContainer.innerHTML = '<p>' + window.languages.shippingEstimatorNoResults + '</p>';
          } else {
            var html = '';

            if (shippingRates.length === 1) {
              html += '<p>' + window.languages.shippingEstimatorOneResult + '</p><ul>';
            } else {
              html += '<p>' + window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length) + '</p><ul>';
            }

            shippingRates.forEach(function (item) {
              html += '<li>' + item['name'] + ': ' + Currency.formatMoney(item['price'], window.theme.moneyFormat) + '</li>';
            });

            html += '</ul>';

            resultsContainer.firstElementChild.innerHTML = html;
          }

          TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, { autoAlpha: 0, y: -15 }, { autoAlpha: 1, y: 0, delay: 0.35 });

          errorContainer.style.display = 'none';
          resultsContainer.style.display = 'block';

          Animation.slideDown(resultsContainer);
        } else {
          var errorHtml = '';

          Object.keys(result).forEach(function (key) {
            errorHtml += '<li class="alert__errorItem">' + key + ' ' + result[key] + '</li>';
          });

          errorContainer.innerHTML = '<ul class="alert__errorList">' + errorHtml + '</ul>';

          resultsContainer.style.display = 'none';
          errorContainer.style.display = 'block';
        }
      });
    });
  }
}